import React, { useEffect, Suspense } from "react";
import { BrowserRouter } from "react-router-dom";
import NavBar from "./views/00_NavBar/NavBar";
import Routes from "../router/Routes";

function App() {

    const pathName = window.location.pathname;

    return (
        <Suspense fallback={<div>Loading...</div>}>
            <BrowserRouter>
                <NavBar/>
                <Routes />
            </BrowserRouter>
        </Suspense>

    );
}

export default App;
